(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["FindYourPlatform"] && !Shopify.designMode) return;
  try {
    (() => {
    const initFindPlatformTracks = (scope = document) => {
      scope.querySelectorAll('[data-fp-track]').forEach((track) => {
        if (track.dataset.fpReady === 'true') return;
        track.dataset.fpReady = 'true';

        let pointerDown = false;
        let startX = 0;
        let startScroll = 0;
        let dragged = false;

        track.addEventListener('pointerdown', (event) => {
          if (event.pointerType !== 'mouse') return;
          pointerDown = true;
          dragged = false;
          startX = event.clientX;
          startScroll = track.scrollLeft;
          track.setPointerCapture(event.pointerId);
        });

        track.addEventListener('pointermove', (event) => {
          if (!pointerDown) return;
          const delta = event.clientX - startX;
          if (Math.abs(delta) > 5) dragged = true;
          track.scrollLeft = startScroll - delta;
        });

        const finishPointer = () => {
          pointerDown = false;
        };

        track.addEventListener('pointerup', finishPointer);
        track.addEventListener('pointercancel', finishPointer);

        track.querySelectorAll('a').forEach((link) => {
          link.addEventListener('click', (event) => {
            if (!dragged) return;
            event.preventDefault();
            dragged = false;
          });
        });

      });
    };

    initFindPlatformTracks();

    document.addEventListener('shopify:block:load', (event) => {
      initFindPlatformTracks(event.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
